import { useMemo, useState } from 'react'
import type { Location, PrescriberLocationProfile } from '../../../types/location'

/** Rows used with `useLocationSearch`: org locations or prescriber location-profile payloads. */
export type LocationSearchItem = Location | PrescriberLocationProfile

function filterLocationsByQuery<T extends LocationSearchItem>(
  locations: T[],
  searchQuery: string
): T[] {
  const q = searchQuery.trim().toLowerCase()
  if (!q) return locations
  return locations.filter(
    (loc) => loc.name.toLowerCase().includes(q) || (loc.suburb?.toLowerCase().includes(q) ?? false)
  )
}

export function useLocationSearch<T extends LocationSearchItem>(locations: T[]) {
  const [searchQuery, setSearchQuery] = useState('')

  const filteredLocations = useMemo(
    (): T[] => filterLocationsByQuery(locations, searchQuery),
    [locations, searchQuery]
  )

  return { searchQuery, setSearchQuery, filteredLocations }
}
